// Modules
import { connect } from "react-redux";
import React from "react";
import PropTypes from "prop-types";
import filter from "lodash/filter";
import pick from "lodash/pick";
import startCase from "lodash/startCase";
import find from "lodash/find";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import mapValues from "lodash/mapValues";
import moment from "moment";
import sortBy from "lodash/sortBy";

import { RoundLoader } from "components/widgets/state-indicators/loader";
import { Table } from "components/content-containers/tables";
import { registerSocket } from "services/socket";
import Person from "services/data/person";
import SVG from "components/widgets/icons/svg";
import UserInitials from "components/models/user/user-initials";
import logo from "assets/images/icon.png";

class UserDashboard extends React.Component {
  static propTypes = {
    query: PropTypes.object,
    users: PropTypes.array,
    teams: PropTypes.array
  };

  constructor() {
    super();
    this.state = { usersData: {} };
  }

  componentDidMount() {
    this.deregisterSocket = registerSocket("userTaskTime", (usersData) => this.setState({ usersData }));
  }

  componentWillUnmount() {
    this.deregisterSocket("userTaskTime");
  }

  render() {
    const teams = this.props.teams;
    const users = this.props.filteredUsers || this.props.users;
    const query = this.props.query;
    const { usersData } = this.state;

    const filteredUsers = filter(users, Person.isPraecePerson);
    let groupedUsers = groupBy(filteredUsers, (user) => get(user, 'team.id'));

    if (query.team && teams) {
      const team = find(teams, { name: startCase(query.team) });
      groupedUsers = pick(groupedUsers, [team.id]);
    }

    const sortedGroupedUsers = mapValues(groupedUsers, (userGroup) =>
      sortBy(userGroup, ["role", "firstName", "lastName"])
    );
    const sortedTeams = map(teams, (team) => ({
      team,
      users: sortedGroupedUsers[team.id]
    }));

    if (!users || !users.length) {
      return <RoundLoader className="dashboard-loader" />;
    }

    return (
      <div className="user-dashboard">
        <img id="logo" src={logo} alt="logo" />
        <Table className="text-white">
          <thead>
            <tr>
              <th className="collapse-width invisible-cell" />
              <th className="collapse-width invisible-cell" />
              <th className="collapse-width invisible-cell" />
              <th className="center-align" colSpan="2">
                <SVG src="svg/task.svg" />
                Tasks
              </th>
              <th className="center-align" colSpan="2">
                <SVG src="svg/time-report.svg" />
                Time
              </th>
            </tr>
            <tr>
              <th />
              <th />
              <th />
              <th className="right-align">Today</th>
              <th className="right-align">+1D</th>
              <th className="right-align">+7D</th>
              <th className="right-align">{moment().format("M/D")}</th>
              <th className="right-align">
                {moment().subtract(1, "day").format("M/D")}
              </th>
            </tr>
          </thead>
          <tbody>
            {map(sortedTeams, (teamInfo) =>
              map(teamInfo.users, (user) => {
                const userData = usersData[user.id] || {};

                return (
                  <tr key={user.id}>
                    <td
                      style={{ backgroundColor: (teamInfo.team || {}).color }}
                      className="group-indicator"
                    ></td>
                    <td className="on-call-container">
                      {user.onCall && !userData.onActiveCall && (
                        <SVG src="svg/on-call.svg" className="on-call" />
                      )}

                      {userData.onActiveCall && (
                        <SVG src="svg/on-call.svg" className="on-active-call" />
                      )}
                    </td>
                    <td>
                      <UserInitials user={user} elementType="span" />
                    </td>
                    <td className="right-align">{userData.tasksToday || 0}</td>
                    <td className="right-align">
                      {userData.tasksTomorrow || 0}
                    </td>
                    <td className="right-align">
                      {userData.tasksThisWeek || 0}
                    </td>
                    <td className="right-align">
                      {(userData.timeToday || 0).toFixed(2)}
                    </td>
                    <td className="right-align">
                      {(userData.timeYesterday || 0).toFixed(2)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default connect((state) => ({
  query: state.location.query,
  users: state.pageData.selectUsers,
  teams: state.pageData.teams
}))(UserDashboard);
